import { Role, AllRoles, AdminRoles } from "@/helper/roles";

const manufacturerRoutes = [
  {
    path: "manufacturer",
    meta: { translated: false, label: "global.manufacturer" },
    component: {
      render(c) {
        return c("router-view");
      },
    },
    children: [
      {
        path: "dashboard",
        alias: [""],
        name: "Manufacturer Dashboard",
        meta: { translated: false, label: "global.dashboard", authorize: AllRoles },
        component: () => import("@/views/manufacturer-views/Dashboard"),
      },

      {
        path: "products",
        meta: { translated: false, label: "product.products", authorize: AdminRoles },
        component: {
          render(c) {
            return c("router-view");
          },
        },
        children: [
          {
            path: "",
            name: "ManufacturerProducts",
            meta: { translated: false, label: "product.products", authorize: AdminRoles },
            component: () => import("@/views/manufacturer-views/products/List"),
          },
          {
            path: "add",
            name: "Add New Manufacturer Product",
            meta: { translated: false, label: "product.add_new_product", authorize: AdminRoles },
            component: () => import("@/views/manufacturer-views/products/Item"),
          },
          {
            path: ":id",
            name: "Edit Manufacturer Product",
            meta: { translated: false, label: "product.edit_product", authorize: AdminRoles },
            component: () => import("@/views/manufacturer-views/products/Item"),
          },
        ],
      },
    ],
  },
];

export default manufacturerRoutes;
